module.exports = __webpack_public_path__ + "img/top-image.741d834.webp";